import type { Time } from "../time";

import { type ClockTimeFormat, HourMinutesSeconds, getClockTimeFormat } from "./clock-time-format";
import { type CombinedDateTimeFormatWithTime, getCombinedDateTimeFormatWithTime } from "./combined-date-time-format";
import { ABSOLUTE_DATE_FORMAT } from "./date-format";

export interface FormatAbsoluteTimeOptions {
	clockTimeFormat?: ClockTimeFormat;
}

/**
 * TODO STAC-22104 make time required
 */
export function formatAbsoluteTime(
	time: Time = new Date(),
	{ clockTimeFormat = HourMinutesSeconds }: FormatAbsoluteTimeOptions = {},
): CombinedDateTimeFormatWithTime {
	return getCombinedDateTimeFormatWithTime(time, ABSOLUTE_DATE_FORMAT, getClockTimeFormat(clockTimeFormat));
}
